import {INTEREST_GROUPS, LEGACY_INTERESTS} from "./interestGroups";

/**
 * Плоский список известных интересов: каталог по группам плюс legacy-значения
 * прежнего справочника.
 *
 * Legacy включены намеренно — список используется для проверки ввода и для
 * распознавания уже сохранённых у пользователей интересов. В каталоге
 * «Показать все» они не показываются: там рендерятся только INTEREST_GROUPS.
 */
export const ALL_INTERESTS: string[] = [
    ...new Set([...INTEREST_GROUPS.flatMap((group) => group.items), ...LEGACY_INTERESTS]),
];
